import React from 'react';
import PropTypes from 'prop-types';

import './Field.scss';

const Field = ({ id, label, labelWidth, layout, required, containerClasses, childContainerClasses, children }) => {
  const containerClassNames = ['parkchirp--field-container', ...containerClasses];
  if (layout) {
    containerClassNames.push(`parkchirp--field-container--${layout}`);
  }
  if (required) {
    containerClassNames.push('parkchirp--required');
  }

  const childContainerClassNames = ['parkchirp--field-value', ...childContainerClasses];

  return (
    <div className={containerClassNames.join(" ")}>
      {(label) &&
        <label htmlFor={id}
          className={`parkchirp--field-label parkchirp--field-label--${labelWidth}`}
        >{label}</label>
      }
      <div className={childContainerClassNames.join(" ")}>{children}</div>
    </div>
  );
}

Field.defaultProps = {
  containerClasses: [],
  childContainerClasses: [],
  labelWidth: 'sm'
}

Field.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  labelWidth: PropTypes.string,
  layout: PropTypes.string,
  required: PropTypes.bool,
  containerClasses: PropTypes.array,
  childContainerClasses: PropTypes.array,
  children: PropTypes.any
}

export default Field;
